import { EFetchMapDataActionType } from '../../../Map/actions';
import { TReduxActions } from '../../actions';

const initialState = '';

export function nonGeoQueryStringReducer(state: string = initialState, action: TReduxActions): string {
  switch (action.type) {
    case EFetchMapDataActionType.Succeed:
      return action.payload.nonGeoQueryString;
    default:
      return state;
  }
}
